import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import CompactToggle from '~/components/toolbar/shared/CompactToggle';
import {
    lineDeformOptionsState,
    contourAutoSuggestionEnabledState,
} from '~/state/atoms/toolsAtoms';
import ToolTraySlider from './ToolTraySlider';
import { toolTrayRowSx } from './toolTraySx';

const MIN_SPREAD_PERCENT = 1;
const MAX_SPREAD_PERCENT = 100;

export default function LineDeformToolOptions() {
    const [deformOptions, setDeformOptions] = useRecoilState(
        lineDeformOptionsState
    );
    const [autoSuggestEnabled, setAutoSuggestEnabled] = useRecoilState(
        contourAutoSuggestionEnabledState
    );

    const handleSetSpread = (percent: number) => {
        if (percent < MIN_SPREAD_PERCENT || percent > MAX_SPREAD_PERCENT) {
            return;
        }
        setDeformOptions((options) => ({
            ...options,
            spreadPercent: percent,
        }));
    };

    return (
        <Box sx={toolTrayRowSx}>
            <ToolTraySlider
                label="Contour %"
                value={deformOptions.spreadPercent}
                onChange={handleSetSpread}
                step={1}
                min={MIN_SPREAD_PERCENT}
                max={MAX_SPREAD_PERCENT}
                valueText={`${deformOptions.spreadPercent} %`}
                valueMinWidth={30}
            />
            <CompactToggle
                labelId="sliceDeformSuggest"
                tooltipId="sliceDeformSuggestTooltip"
                value={autoSuggestEnabled}
                onChange={(enabled) => setAutoSuggestEnabled(enabled)}
            />
        </Box>
    );
}
